import iconDictionary from '../../../../utils/iconDictionary';

export const CARD_ICON_DICT = {
  GeneralDocs: iconDictionary('documentsGeneral'),
  Payoff: iconDictionary('documentsPayoff'),
  Statements: iconDictionary('documentsStatements'),
};
